import {Icon} from 'antd'

const IconFont = Icon.createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_1518439_bqxa0jlz50t.js',
});
IconFont.pre = 'changgui'
export default IconFont